import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-premium-flyer',
  templateUrl: './premium-flyer.component.html',
  styleUrls: ['./premium-flyer.component.scss']
})
export class PremiumFlyerComponent implements OnInit {

  public premiumFlyerUrl = environment.premiumFlyerUrl

  constructor() { }

  ngOnInit() {
  }

}
